import React from "react";
import LearnVideo from "./learnVideo";

function ContinueLearn () {

    return (
        <div>
  <LearnVideo
  title="How to Add Products to Malidag 2"
  description="This video walks you through the process of uploading and managing products on the Malidag platform."
  videoUrl="https://www.youtube.com/embed/DDQ7vrY3EU4" 
/>

 <LearnVideo
  title="How to Add Products to Malidag 3"
  description="This video walks you through the process of uploading and managing products on the Malidag platform."
  videoUrl="https://www.youtube.com/embed/_nG07k53BXQ"
/>

 <LearnVideo
  title="How to Add Products to Malidag 3
  "
  description="This video walks you through the process of uploading and managing products on the Malidag platform."
  videoUrl="https://www.youtube.com/embed/zwPBVaeX3qk"
/>
        </div>
    )
}

export default ContinueLearn